import { Article } from './BlogCard';
import { BlogI18n } from '@/lib/i18n/blogI18n';

export function filterAndSort(
  articles: Article[],
  query: string,
  sort: 'asc' | 'desc',
): Article[] {
  const q = query.toLowerCase();
  const result = articles.filter(
    (a) =>
      a.title.toLowerCase().includes(q) || a.summary.toLowerCase().includes(q),
  );
  return sort === 'asc' ? [...result].reverse() : result;
}

export function paginate(filtered: Article[], page: number, perPage: number) {
  const totalPages = Math.ceil(filtered.length / perPage);
  const safePage = Math.min(page, totalPages || 1);
  const visible = filtered.slice((safePage - 1) * perPage, safePage * perPage);
  const from = (safePage - 1) * perPage + 1;
  const to = Math.min(safePage * perPage, filtered.length);
  return { visible, totalPages, safePage, from, to };
}

export function scrollToElement(element: HTMLElement | null) {
  if (!element) return;
  const headerHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
      '--header-height',
    ),
  );
  const top =
    element.getBoundingClientRect().top + window.scrollY - headerHeight - 32;
  window.scrollTo({ top, behavior: 'smooth' });
}

export function buildCounterText(
  query: string,
  count: number,
  from: number,
  to: number,
  t: BlogI18n,
): string {
  if (query) {
    return `${count} ${count === 1 ? t.articleFound : t.articlesFound}`;
  }
  return `${from}–${to} ${t.of} ${count} ${count === 1 ? t.article : t.articles}`;
}
